import axios from "axios";

import C from "../constants/constants";

/**
 * API methods for unauthenticated users.
 * @namespace ExternalApi
 */
const ExternalApi = {};

const nonAuthedAxios = axios.create({
  baseURL: C.VITE_APP_EXPRESS_SERVER,
  withCredentials: true,
});

ExternalApi.checkSafeList = async (email) =>
  (await axios.get(`${C.VITE_APP_EXPRESS_SERVER}/1/user/check-safe-list/${email}`)).data;
ExternalApi.signUp = async (email, password, firstName, lastName) =>
  (
    await axios.post(`${C.VITE_APP_EXPRESS_SERVER}/1/user/sign-up`, {
      email,
      firstName,
      lastName,
      password,
    })
  ).data;
ExternalApi.signIn = async (email, password) =>
  (await nonAuthedAxios.post("/1/user/sign-in", { email, password })).data;
ExternalApi.sendPasswordResetEmail = async (email) =>
  axios.post(`${C.VITE_APP_NEST_SERVER}/v2/users/password-reset-email`, { email });
ExternalApi.resetPassword = async (password, token) =>
  (await axios.post(`${C.VITE_APP_EXPRESS_SERVER}/1/user/reset-password/${token}`, { password })).data;
ExternalApi.verifyEmail = async (token) =>
  await axios.post(`${C.VITE_APP_NEST_SERVER}/v2/users/verify-email`, { token });
export default ExternalApi;
